<template>
  <div class="signup">
    <router-link to="/login">
      <div class="back">
        <img src='../assets/images/back@2x.png' alt=""/>
      </div>
    </router-link>
    <div class="title">Sign up</div>
    <div class="input">
	  <div class="input-vp">
        <i class="icon"></i>
        <input type="text" class="username input-view" placeholder="Enter your username" v-model="username" @keydown.enter.prevent="signup"/>
      </div>
      <div class="input-vp">
        <i class="icon"></i>
        <input type="text" class="email input-view" placeholder="Enter your Email" v-model="email" @keydown.enter.prevent="signup"/>
      </div>
      <div class="input-vp">
        <i class="icon"></i>
        <input type="password" class="password input-view" placeholder="Enter your password" v-model="password" @keydown.enter.prevent="signup"/>
      </div>
      <div class="input-vp">
        <i class="icon"></i>
        <input type="password" class="confirm input-view" placeholder="Confirm your password" v-model="confirm" @keydown.enter.prevent="signup"/>
      </div>
    </div>
    <div class="btn btn_signup" @click="signup">Sign up</div>
    <div class="user-argreement">I have read and accepted the  "User Agreement"</div>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Message } from 'element-ui'
  export default {
    data () {
      return {
        username: '',
        email: '',
        password: '',
        confirm: ''
      }
    },
    methods: {
      signup () {
        // 有未填项
        console.log(this.privateKey)
        if (!this.username || !this.email || !this.password || !this.confirm) {
          Message({
            message: 'Empty input!',
            type: 'error'
          })
          return
        }
        // 验证两次输入密码是否一致
        if (this.password !== this.confirm) {
          Message({
            message: 'Entered passwords differ!',
            type: 'error'
          })
          return
        }
        // 发送请求
        this.$emit('show')
        axios.post('/proxy-api/client/user/index/register', qs.stringify({
          username: this.username,
          email: this.email,
          password: this.password,
          useragent: 'web'
        }))
        .then((result) => {
          console.log(result)
          if (result.data.status === '0') {
            this.$emit('hide')
            Message({
              message: 'Please check email to activate',
              type: 'success'
            })
            setTimeout(() => {
              location.href = './'
            }, 1000)
          } else {
            this.$emit('hide')
            Message({
              message: result.data.msg,
              type: 'error'
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$emit('hide')
          Message({
            message: 'Warning!',
            type: 'warning'
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  .main .viewport .btn.btn_signup {
    margin: 20px auto;
  }

  .main {
    .viewport {
	  .signup {
	    .input {
		  .input-vp {
		    .icon {
		      background-image: url("../assets/images/password@2x.png");
		    }
		    &:first-child {
		      .icon {
		        background-image: url("../assets/images/icon_user@2x.png");
		      }
		    }
		    &:nth-child(2) {
		      .icon {
		        background-image: url("../assets/images/email@2x.png");		
		      }
		    }
		  }
		}
	  }
	}
  }
</style>



// WEBPACK FOOTER //
// Signup.vue?9a362392